import jwtDecode from 'jwt-decode';

import { createReducer } from '../utils/misc';
import {
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILURE,
    LOGIN_USER_REQUEST,
    LOGOUT_USER,
    REGISTER_USER_FAILURE,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    TOKEN_REFRESH_REQUEST,
    TOKEN_REFRESH_SUCCESS,
    TOKEN_REFRESH_FAILURE,
} from '../constants/index';

const initialState = {
    userName: null,
    isAuthenticated: localStorage.getItem('access-token') != null,
    isAuthenticating: false,
    statusText: null,
    isRegistering: false,
    isRegistered: false,
    registerStatusText: null,
    userId: null,
};

export default createReducer(initialState, {
    [LOGIN_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            isAuthenticating: true,
            statusText: null,
        }),
    [LOGIN_USER_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isAuthenticating: false,
            isAuthenticated: true,
            statusText: null,
            userId: `${payload.userId}`
        }),
    [LOGIN_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isAuthenticating: false,
            isAuthenticated: false,
            userName: null,
            statusText: `${payload.statusText}`,
        }),
    [LOGOUT_USER]: (state) =>
        Object.assign({}, state, {
            isAuthenticated: false,
            isAuthenticating: false,
            userName: null,
            statusText: 'Deslogueo exitoso',
        }),
    [REGISTER_USER_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isAuthenticating: false,
            isAuthenticated: false,
            isRegistering: false,
            statusText: 'Un representante lo contactara pronto',

        }),
    [REGISTER_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            isRegistering: true,
        }),
    [REGISTER_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isAuthenticated: false,
            userName: null,
            statusText: `${payload.statusText}`,
        }),
    [TOKEN_REFRESH_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: true,
            registerStatusText: `Fetching token refresh: ${payload.status} ${payload.statusText}`,
        }),
    [TOKEN_REFRESH_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: false,
            isAuthenticated: true,
            isRegistering: false,
            access_token: payload.token,
        }),
    [TOKEN_REFRESH_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: action.isFetching,
            isAuthenticated: action.isAuthenticated,
            errorMessage: action.errorMessage,
            registerStatusText: `Register Error: ${payload.status} ${payload.statusText}`,
        }),   
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js